var _path, _path2, _circle, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.379 88.277H8.828A8.828 8.828 0 0 0 0 97.104v317.793a8.829 8.829 0 0 0 8.828 8.828H185.38V88.277h-.001z",
    fill: "#73af00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.45,
    cy: 256.001,
    r: 79.38,
    fill: "#ffe15a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.932 229.518v35.31c0 14.603-11.88 26.483-26.483 26.483s-26.483-11.88-26.483-26.483v-35.31h52.966m8.827-17.655h-70.621a8.829 8.829 0 0 0-8.828 8.828v44.138c0 24.376 19.762 44.138 44.138 44.138s44.138-19.762 44.138-44.138v-44.138a8.827 8.827 0 0 0-8.827-8.828z",
    fill: "#ff4b55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.932 229.518v35.31c0 14.603-11.88 26.483-26.483 26.483s-26.483-11.88-26.483-26.483v-35.31h52.966",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150.07,
    cy: 220.691,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.69,
    cy: 220.691,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.07,
    cy: 256.001,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.69,
    cy: 256.001,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.38,
    cy: 220.691,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.88,
    cy: 288.551,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.4,
    cy: 288.551,
    r: 4.414
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.149 253.763v7.602c0 3.144-2.558 5.702-5.702 5.702s-5.702-2.558-5.702-5.702v-7.602h11.404M191.149 235.741v7.602c0 3.144-2.558 5.702-5.702 5.702s-5.702-2.558-5.702-5.702v-7.602h11.404M191.149 271.97v7.602c0 3.144-2.558 5.702-5.702 5.702s-5.702-2.558-5.702-5.702v-7.602h11.404M206.506 253.763v7.602c0 3.144-2.558 5.702-5.702 5.702s-5.702-2.558-5.702-5.702v-7.602h11.404M175.794 253.763v7.602c0 3.144-2.558 5.702-5.702 5.702s-5.702-2.558-5.702-5.702v-7.602h11.404"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.61b94f095f9d53bed0ea63661a211a73.svg";
export { ForwardRef as ReactComponent };